export const resolveAppApiUrl = () => {
    if(window.origin.split('://')[0] === "https") {
        return process.env.REACT_APP_API_URL
    }

    return process.env.REACT_APP_API_URL_HTTP
}
